function NotificationBellCircled({ className, size = 96 }: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="48" cy="48" r="48" fill="#F3F2F5" />
      <g clipPath="url(#clip0_14914_3094)">
        <path
          d="M47.9983 27.6667C46.5233 27.6667 45.3317 28.8583 45.3317 30.3333V31.9333C39.2483 33.1667 34.665 38.55 34.665 45V46.5667C34.665 50.4833 33.2233 54.2667 30.6233 57.2L30.0067 57.8917C29.3067 58.675 29.14 59.8 29.565 60.7583C29.99 61.7167 30.9483 62.3333 31.9983 62.3333H63.9983C65.0483 62.3333 65.9983 61.7167 66.4317 60.7583C66.865 59.8 66.69 58.675 65.99 57.8917L65.3733 57.2C62.7733 54.2667 61.3317 50.4917 61.3317 46.5667V45C61.3317 38.55 56.7483 33.1667 50.665 31.9333V30.3333C50.665 28.8583 49.4733 27.6667 47.9983 27.6667ZM51.7733 68.775C52.7733 67.775 53.3317 66.4167 53.3317 65H47.9983H42.665C42.665 66.4167 43.2233 67.775 44.2233 68.775C45.2233 69.775 46.5817 70.3333 47.9983 70.3333C49.415 70.3333 50.7733 69.775 51.7733 68.775Z"
          fill="#736E7D"
        />
      </g>
      <defs>
        <clipPath id="clip0_14914_3094">
          <rect width="37.3333" height="42.6667" fill="white" transform="translate(29.3333 27.6667)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NotificationBellCircled
